import { Expose, Type } from 'class-transformer';
import { SupportEventStatusEnum } from '../../../../store/support-management/SupportTypes';
import { VisittContactResponseDto } from './visitt-contact.response.dto';
import { CategoryResponseDto } from './category-response.dto';

export class VisittEventResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'subject' })
  subject: string;
  @Expose({ name: 'visitt_order_id' })
  visittOrderId: string;
  @Expose({ name: 'status' })
  status: SupportEventStatusEnum;
  @Expose({ name: 'contact' })
  @Type(() => VisittContactResponseDto)
  contact: VisittContactResponseDto;
  @Expose({ name: 'category' })
  @Type(() => CategoryResponseDto)
  category: CategoryResponseDto;
  @Expose({ name: 'sub_category' })
  @Type(() => CategoryResponseDto)
  subCategory: CategoryResponseDto;
  @Expose({ name: 'created_at' })
  createdAt: number;
}
